import { BasicClient } from '@/utils/httpClient'

export default class SichernIntegration {
  client;
  constructor() {
    this.client = new BasicClient();
  }
  checkIntegrationSichernPeople(type) {
    return Promise.resolve({ data: { data: { enabled: false } } })
  }
  checkHalfDay(id) { 
    return this.client.exec(`externalapis/sichernpeople/absences-type/${id}`, "GET");
  }
  hasChileanHolidayModel() {
    return this.client.exec(
        `externalapis/sichernpeople/hasChileanHolidayModel`, 
        'GET'
    )
  }
  getAddressTypes() {
    return this.client.exec(
        '/externalapis/sichernpeople/addresstypes',
        'GET'
    )
  }
  getCountries() {
    return this.client.exec(
        '/externalapis/sichernpeople/countries',
        'GET'
    )
  }
  getStates(params) {
    return this.client.exec(
        `/externalapis/sichernpeople/states/${params.idCountry}`,
        'GET'
    )
  }
  getCities(params) {
    return this.client.exec(
        `/externalapis/sichernpeople/cities/${params.idCountry}/${params.idState}`,
        'GET',
    )
  }
  
  getDetailedBalance() {
    return this.client.exec(`/v2/licensesUser/holidaysBalanceDetailsVp`, 'GET')
  }

  getDetailedBalances(params) {
    return this.client.exec(`/manager/myteam/holidays-balance-details-vp/${params.id}`, 'GET')
  }

  getHolidayDetailsVP(id) {
    return this.client.exec(`/v2/licensesUser/holidaysDetailsVp/${id}`, 'GET')
  }

  getIntegrations() {
    return this.client.exec('/externalapis/integrations', 'GET')
  }
}
